module.exports = __webpack_public_path__ + "media/images/landing/data/eno-bc2f88c4eccf57d4317c61ff8351dfaa.png";